import { DocumentType } from '../types/report';

/** True when the document is an optional supporting upload (not primary ID / legal docs). */
export function isAdditionalDocument(documentType: string): boolean {
  return documentType === DocumentType.ADDITIONAL;
}

/** Primary (non-additional) documents for a report. */
export function filterPrimaryDocuments<T extends { documentType: string }>(documents: T[]): T[] {
  return documents.filter((d) => !isAdditionalDocument(d.documentType));
}
